import { render, staticRenderFns } from "./ArrowLong.vue?vue&type=template&id=25b9984e"
import script from "./ArrowLong.vue?vue&type=script&lang=js"
export * from "./ArrowLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports